import { Courses } from "../courses"
import { CreateCourse } from "../createCourse"
import { Reports } from "../reports"

export const WorkforceCreate = ({pageSwap, CustomerStage }) =>  {
    return(
        <CreateCourse 
            
            CustomerStage={CustomerStage}
       />
    )
}